import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LocationProvider } from "./contexts/LocationContext";
import { I18nProvider } from "./i18n/I18nContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import WelcomePage from "./pages/WelcomePage";
import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import DiscoverPage from "./pages/DiscoverPage";
import ShopOwnerPage from "./pages/ShopOwnerPage";
import DashboardPage from "./pages/DashboardPage";
import ShopRegistryPage from "./pages/ShopRegistryPage";
import RegistrazioneAttivitaPage from "./pages/RegistrazioneAttivitaPage";
import InventarioPage from "./pages/InventarioPage";
import CassaPage from "./pages/CassaPage";
import ShopPage from "./pages/ShopPage";
import FavoritesPage from "./pages/FavoritesPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CookiePage from "./pages/CookiePage";
import SupportPage from "./pages/SupportPage";
import StrumentiPage from "./pages/StrumentiPage";
import ToolGate from "./components/ToolGate";

// Components
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<WelcomePage />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/prodotto/:id" element={<ProductDetailPage />} />
      <Route path="/scopri" element={<DiscoverPage />} />
      <Route path="/negoziante" element={<ShopOwnerPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/inventario" element={<ProtectedRoute><ToolGate tool="inventario"><InventarioPage /></ToolGate></ProtectedRoute>} />
      <Route path="/cassa" element={<ProtectedRoute><ToolGate tool="cassa"><CassaPage /></ToolGate></ProtectedRoute>} />
      <Route path="/dati-negozio" element={<ProtectedRoute><ShopRegistryPage /></ProtectedRoute>} />
      <Route path="/registrazione-attivita" element={<RegistrazioneAttivitaPage />} />
      <Route path="/negozio/:id" element={<ShopPage />} />
      <Route path="/preferiti" element={<ProtectedRoute><FavoritesPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboardPage /></ProtectedRoute>} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/termini" element={<TermsPage />} />
      <Route path="/cookie" element={<CookiePage />} />
      <Route path="/assistenza" element={<SupportPage />} />
      <Route path="/strumenti" element={<ProtectedRoute><StrumentiPage /></ProtectedRoute>} />
      <Route path="/impostazioni" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <LocationProvider>
              <AppRouter />
              <Toaster position="top-center" />
            </LocationProvider>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
